"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const clearBlock_1 = require("./clearBlock");
const read_1 = require("../read");
const nestedContentEditOnBlocks_1 = require("./nestedContentEditOnBlocks");
exports.nestedContentEdit = (block) => {
    return Object.assign(Object.assign({}, clearBlock_1.clearBlock(block, false)), { childBlocks: nestedContentEditOnBlocks_1.nestedContentEditOnBlocks(block.childBlocks ? block.childBlocks : []), contentStr: read_1.getEmailTemplateBlockData(block, 'importedContent', true, true) });
};
//# sourceMappingURL=nestedContentEdit.js.map